<template>
    <h2 class="title">
        {{ Language.say(title)}}
    </h2>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language      from '@/js/Shared/Language/Language';


  const props = defineProps({
    title: {
      default: '',
    }
  })
</script>